export default __webpack_public_path__ + "static/media/Athena_Desktop.d0740913.mp4";